import { Component, inject, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { of, throwError } from 'rxjs';
import { retryWhen, delay, take, tap, mergeMap } from 'rxjs/operators';
import { UserGuideTopic } from 'src/models/user-guide-topic';
import { UserGuideService } from 'src/services/user-guide/user-guide.service';

@Component({
  selector: 'app-guides',
  templateUrl: './guides.component.html',
  styleUrls: ['./guides.component.scss']
})
export class GuidesComponent implements OnInit {
  guideService = inject(UserGuideService);
  guides: Array<UserGuideTopic>;
  loading: boolean;

  constructor(private meta: Meta) {}

  ngOnInit(): void {
    this.meta.addTag({ name: 'description', content: "Guides d'Utilisation" });
    this.meta.addTag({ name: 'keywords', content: 'BSTP Guinée, BSTP, bstpgn, ' });
    this.meta.addTag({ name: 'author', content: 'BSTP Guinée' });
    this.loading = true;
    this.guideService.list().pipe(
      retryWhen(errors =>
        errors.pipe(
          mergeMap((error) => {
            // Si c'est une erreur serveur (500+), on réessaie après un délai
            if (error.status >= 500) {
              console.log("Erreur serveur, nouvelle tentative...");
              return of(error).pipe(delay(500));
            }
            // Sinon (404, 400, etc.), on propage immédiatement l'erreur
            return throwError(() => error);
          }),
          take(3) // Max 3 tentatives pour les erreurs 5xx
        )
      )
    ).subscribe(response => {
      this.loading = false;
        this.guides = response;
    });
  }

}
